import React, {useState} from 'react';
import MovieCastMaster from './MovieCastMaster.js';
import MovieCastDetail from './MovieCastDetail.js';

const MovieCastContainer = () => {
    const [personId, setPersonId] = useState("");
    //const [personId] = useState("");

    return(
    <>
      <div className="left-half">
        <MovieCastMaster personId={personId} setPersonId={setPersonId}/>
      </div>
      <div className="right-half">
        {/*<MovieCastDetail personId={personId}/>*/}
        <MovieCastDetail personId={personId}/>
      </div>
    </>
  );
};  
export default MovieCastContainer;  